<template>
  <div class="mainentrance">
    <b-container>
      <b-row class="">
        <b-col cols="12" md="5" class="d-flex align-items-center" order="2" order-md="1">
          <div class="my-5 px-3 w-100">
            <h6 class="my-0" style="color: grey">Ville de Quebec</h6>
            <h2 style="color: black" class="font-weight-bold">
              Beauté Intégrale
            </h2>
            <br />
            <h5>{{ $t("clinic-main.jumbo-message1") }}</h5>
            <h5>{{ $t("clinic-main.jumbo-message2") }}</h5>
            <h5>{{ $t("clinic-main.jumbo-message3") }}</h5>
            <div class="my-3">
              <appt-button v-bind:color="'d'" />
            </div>
            <div class="d-flex">
              <div class="ml-md-auto mt-3 mt-md-2">
                <a href="https://www.facebook.com/beauteintegrale">
                  <i class="fa fa-facebook-official fa-2x mx-3" style="color: black"></i></a>

                <a href="https://www.instagram.com/beauteintegrale/">
                  <i class="fa fa-instagram fa-2x mx-3" style="color: black"></i>
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="7" class="d-flex align-items-center px-0 m-borders" order="1" order-md="2">
          <div class="video-container">
            <video playsinline autoplay muted loop class="video">
              <source src="https://media.milligram-health.com/beaute-integrale-web/videos/BI_Facial_Video_2.mp4"
                type="video/mp4" />
            </video>
          </div>
          <!-- <b-img
            src="https://res.cloudinary.com/milligram/image/upload/ar_4:3,c_fill,h_500/v1640892275/BeauteIntegrale/bi2_yaar1y.jpg"
            fluid
            center
          ></b-img> -->
        </b-col>
      </b-row>

      <b-row class="tb">
        <b-col cols="12" md="8" class="m-borders retail-clinic bi-col">
          <div class="row h-100">
            <div class="col-sm-12 align-self-end py-3">
              <div>
                <h2>{{ $t("main-screen.retail.title") }}</h2>
                <!-- <p>{{ $t('main-screen.retail.description') }}</p> -->
                <b-button squared variant="outline-light" size="md" class="main-button shadow" to="clinic/">{{
              $t("main-screen.retail.button_text") }}
                  <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon></b-button>
              </div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" md="4" class="bi-col">
                <div class="row h-100 background-giftcard m-borders">
                    <div class="col-sm-12 align-self-end py-3">
                      <div>
                        <h2>{{ $t("main-screen.gift.title") }}</h2>
                        <b-button squared variant="outline-light" size="md" class="main-button shadow"
                          href="https://moncoachbeaute.ca/" target="_blank">{{
                      $t("main-screen.gift.button_text") }}
                          <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon></b-button>
                      </div>
                    </div>
                  </div>
          </b-col> 

        <!-- <b-col cols="12" md="4" class="bi-col">
          <div class="row h-100 m-borders">
            <div class="col-sm-12 py-3 bi-h-25 d-flex flex-grow align-contents-end"
              style="background-color: black; width: 100%">
              <div class="align-self-end w-100">
                <b-form-input type="search" name="search" style="height: 35px" v-model="searchProductName"
                  placeholder="Recherche de produits..."></b-form-input>
                <b-button squared variant="outline-light" size="md" class="main-button shadow mt-2"
                  @click.prevent="searchProducts()">{{ $t("main-screen.blog.button_text") }}
                  <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon></b-button>
              </div>
            </div>

            <div class="col-sm-12 bi-h-75 background-onlinestore d-flex bt">
              <div class="align-self-end py-3">
                <div>
                  <h2>{{ $t("main-screen.online.title") }}</h2>
                  <b-button squared variant="outline-light" size="md" class="main-button shadow"
                    href="https://moncoachbeaute.ca" target="_blank">{{ $t("main-screen.online.button_text") }}
                    <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon></b-button>
                </div>
              </div>
            </div>
          </div>
        </b-col> -->

        <b-col cols="12" md="6" class="m-borders online-consultation bi-col">
          <div class="row h-100">
            <div class="col-sm-12 align-self-end py-3">
              <div>
                <h2>{{ $t("main-screen.online_consultation.title") }}</h2>
                <b-button squared variant="outline-light" size="md" class="main-button shadow"
                  to="onlineconsultation/">{{ $t("main-screen.online_consultation.button_text") }}
                  <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon>
                </b-button>
              </div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" md="6" class="bi-col">
          <div class="row h-100 background-athome m-borders">
            <div class="col-sm-12 align-self-end py-3 bi-card">
              <div>
                <h2>{{ $t("main-screen.at-home.title") }}</h2>
                <!-- <p>{{ $t('main-screen.at-home.description') }}</p> -->
                <b-button squared variant="outline-light" size="md" class="main-button shadow" href="https://reservations.beauteintegrale.ca/v2/#book">{{
              $t("main-screen.at-home.button_text") }}
              
                  <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon></b-button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="tb2">
        <b-col cols="12" md="8" class="background-assessment m-borders bi-col">
          <div class="row h-100">
            <div class="col-sm-12 align-self-end py-3">
              <div>
                <h2>{{ $t("main-screen.skincare_assessment.title") }}</h2>
                <b-button squared variant="outline-light" size="md" class="main-button shadow"
                  to="/online/assessment/routine">{{ $t("main-screen.skincare_assessment.button_text") }}
                  <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon></b-button>
              </div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" md="4" class="bi-col">
          <div class="row h-50 background-social m-borders">
            <div class="col-sm-12 align-self-center py-3">
              <div class="d-flex justify-content-around">
                <a href="https://www.facebook.com/beauteintegrale">
                  <i class="fa fa-facebook-official fa-2x mx-3" style="color: white; font-size: 60px"></i></a>

                <a href="https://www.instagram.com/beauteintegrale/">
                  <i class="fa fa-instagram fa-2x mx-3" style="color: white; font-size: 60px"></i>
                </a>

                <!-- <h3>
                  <a href="">
                  <i class="fa fa-twitter fa-2x mx-3" style="color: white"></i>
                  </a>
                </h3> -->
              </div>
            </div>
          </div>

          <div class="row h-50 m-borders" style="background-color: #e8e8e8">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2 style="color: black">{{ $t("main-screen.faqs.title") }}</h2>
                <b-button squared variant="dark" size="md" class="main-button shadow" to="/faqs/">{{
              $t("main-screen.faqs.button_text") }}
                  <b-icon icon="chevron-right" font-scale="0.95" aria-hidden="true"></b-icon></b-button>
              </div>
            </div>
          </div>

        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "mainentrance",

  data() {
    return {
      msg: "Welcome to BI",
      searchProductName: "",
    };
  },
  methods: {
    social() {
      this.$router.push({ name: "social" });
    },
    searchProducts() {
      window.location.href =
        "https://moncoachbeaute.ca/search?q=" + this.searchProductName;
      this.searchProductName = "";
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tb {
  min-height: calc(90vh * 0.66);
}

.tb2 {
  min-height: calc(90vh * 0.33);
}

.bi-col {
  min-height: 500px;
}

.bi-card {
  min-height: fit-content !important;
}

.bi-h-25 {
  height: 25%;
}

.bi-h-75 {
  height: 75%;
}

.m-borders {
  border: 3px solid white;
}

.bt {
  border-top: 6px solid white;
}

.b-borders {
  border: 1px solid black;
}

.retail-clinic {
  background-image: linear-gradient(39deg,
      rgba(0, 0, 0, 0.6) 4%,
      rgba(0, 0, 0, 0.1) 100%),
    url("https://media.beauteintegrale.ca/beaute-integrale-web/images/bi_facial_2024_2.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.online-consultation {
  background-image: linear-gradient(39deg,
      rgba(0, 0, 0, 0.4) 4%,
      rgba(0, 0, 0, 0.1) 100%),
    url("../assets/images/7O9A1099.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: black;
}

.background-onlinestore {
  background-image: linear-gradient(39deg,
      rgba(0, 0, 0, 0.6) 4%,
      rgba(0, 0, 0, 0.1) 100%),
    url("../assets/images/onlinestore3.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.background-athome {
  background-image: linear-gradient(39deg,
      rgba(0, 0, 0, 0.4) 4%,
      rgba(0, 0, 0, 0.1) 100%),
    url("../assets/images/online_reservation_1.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: black !important;
}

.background-assessment {
  background-image: linear-gradient(39deg,
      rgba(0, 0, 0, 0.4) 4%,
      rgba(0, 0, 0, 0.1) 100%),
    url("../assets/images/formulary.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.background-giftcard {
  background-image: linear-gradient(39deg,
      rgba(0, 0, 0, 0.7) 4%,
      rgba(0, 0, 0, 0.1) 100%),
    url("https://media.beauteintegrale.ca/beaute-integrale-web/images/gift certificate image.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.background-searchproducts {
  background-image: linear-gradient(39deg,
      rgba(0, 0, 0, 0.4) 4%,
      rgba(0, 0, 0, 0.1) 100%),
    url("../assets/images/onlinestore1.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: "cover";
}

.background-social {
  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5),
                       rgba(0, 0, 0, 0.3)), url('../assets/images/onlinestore2.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 'cover'; */
  /* background-color:#E8E8E8; */
  background-color: black;
  color: white;
}

h2 {
  color: white;
  font-weight: 400;
}

p {
  color: white;
}

.search-container button {
  padding: 6px 10px;
  margin-right: 0px;
  background: #ddd;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.search-container input[type="text"] {
  padding: 6px;
  margin-top: 8px;
  font-size: 16px;
  border: none;
}

.main-button {
  min-width: 175px;
  text-transform: capitalize;
  font-weight: 500;
  /* background: linear-gradient(77deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.25)); */
}

.main-button:hover {
  background: white;
}

@media only screen and (max-width: 600px) {
  .row {
    min-height: fit-content;
  }

  .bi-col {
    min-height: 300px;
  }

  .bi-h-25 {
    height: 115px;
  }

  .bi-h-75 {
    height: calc(100% - 115px);
  }
}

.video-container {
  /* width is set as 100% here. any width can be specified as per requirement */
  width: 100%;
  padding-top: 56.25%;
  height: 100%;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.video {
  /* width: 100%; */
  width: auto;
  height: 100%;
  position: absolute;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Main3.vue